import { Validator } from 'jsonschema';
import ApiService from '../api/ApiService';

const validator = new Validator();

const expectedVehicleDatas = {
  id: 'vehicleDatas',
  type: 'object',
  properties: {
    vin: { type: 'string' },
    // dateOfRelease: { type: "string", pattern: "^[0-9]{4}-[0-9]{2}-[0-9]{2}.*" },
    // registration: { type: "string" },
    dateRelease: { type: 'string', pattern: '^[0-9]{4}-[0-9]{2}-[0-9]{2}.*' },
    // dateGrayCard: { type: "string", pattern: "^[0-9]{4}-[0-9]{2}-[0-9]{2}.*" },
    makeId: { type: 'number' },
    makeName: { type: 'string' },
    modelId: { type: 'number' },
    modelName: { type: 'string' },
    bodyId: { type: 'number' },
    bodyName: { type: 'string' },
    fuelId: { type: 'number' },
    fuelName: { type: 'string' },
    gearboxId: { type: 'number' },
    gearboxName: { type: 'string' },
    doors: { type: 'number' },
    seats: { type: 'number' },
    engine: { type: 'number' },
    // fiscal: { type: "number" },
    kw: { type: 'number' },
    liter: { type: 'number' },
  },
  required: [
    'vin',
    'dateRelease',
    'makeId',
    'makeName',
    'modelId',
    'modelName',
    'bodyId',
    'bodyName',
    'fuelId',
    'fuelName',
    'gearboxId',
    'gearboxName',
    'doors',
    'seats',
    'engine',
    'kw',
    'liter',
  ],
};

// Get Vehicle by VIN
export default async function getVehicleByVin(vin, country, registrationDate = null, language, methode = 'V') {
  const queryData = {
    refresh: true,
    identMethod: methode,
    origin: 'autobizCarcheck',
  };
  if (registrationDate !== null) {
    queryData.registrationDate = registrationDate;
  }
  if (methode === 'R') {
    queryData.meta = true;
  }
  if (country === 'BE') queryData.language = language;
  const res = await ApiService('getVehiculeByVin', { vin, country }, queryData);

  const vehicle = res.data;

  const validation = validator.validate(vehicle, expectedVehicleDatas);

  return [vehicle, validation.errors];
}
